/**
 * Dom Figueira: parcela sempre em 10x sem juros.
 * O tema recalculava a parcela dividindo por 12 ao trocar cor/tamanho.
 * Este código corrige o valor logo depois, usando o preço mostrado na página.
 */
(function () {
  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function precoAtual() {
    var el = document.querySelector('.product-meta__price-list-container [data-product-price-list] .price--large') ||
             document.querySelector('.product-meta__price-list-container .price--highlight') ||
             document.querySelector('.product-meta__price-list-container .price');
    if (!el) return null;
    var clone = el.cloneNode(true);
    var hidden = clone.querySelector('.visually-hidden');
    if (hidden) hidden.remove();
    var txt = clone.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
    var n = parseFloat(txt);
    return isNaN(n) ? null : n;
  }

  function corrigir() {
    var alvo = document.getElementById('parcela');
    var preco = precoAtual();
    if (!alvo || !preco) return;
    var certo = fmt.format(Math.round(preco / 10 * 100) / 100);
    if (alvo.textContent.trim() !== certo) alvo.textContent = certo;
  }

  function iniciar() {
    corrigir();
    var box = document.querySelector('.atualizacao-marcos');
    if (box && window.MutationObserver) {
      new MutationObserver(function () { corrigir(); }).observe(box, { childList: true, subtree: true, characterData: true });
    }
    var precoBox = document.querySelector('.product-meta__price-list-container');
    if (precoBox && window.MutationObserver) {
      new MutationObserver(function () { corrigir(); }).observe(precoBox, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('variant:changed', function () { setTimeout(corrigir, 0); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
